import type { SlideChapterDefinition } from '@/components/SlideWizard'
import Slide1Title from './slides/Slide1Title'
import Slide2Breathe from './slides/Slide2Breathe'
import Slide3StopContact from './slides/Slide3StopContact'
import Slide4CallBank from './slides/Slide4CallBank'
import Slide5LockAccounts from './slides/Slide5LockAccounts'
import Slide6Document from './slides/Slide6Document'
import Slide7Report from './slides/Slide7Report'
import Slide8TellSomeone from './slides/Slide8TellSomeone'
import Slide9RecoveryScam from './slides/Slide9RecoveryScam'
import Slide10Finale from './slides/Slide10Finale'

export const whatToDoV2Chapter: SlideChapterDefinition = {
  id: 'what-to-do-v2',
  title: 'If You’re Scammed',
  description: 'How to respond, recover, and get back in control.',
  estimatedMinutes: 7,
  slides: [
    { id: 'wtdv2-title', component: Slide1Title, label: 'Introduction' },
    { id: 'wtdv2-breathe', component: Slide2Breathe, label: 'First, breathe' },
    { id: 'wtdv2-stop-contact', component: Slide3StopContact, label: 'Stop all contact' },
    { id: 'wtdv2-call-bank', component: Slide4CallBank, label: 'If money moved' },
    { id: 'wtdv2-lock-accounts', component: Slide5LockAccounts, label: 'Lock your accounts' },
    { id: 'wtdv2-document', component: Slide6Document, label: 'Document everything' },
    { id: 'wtdv2-report', component: Slide7Report, label: 'Report it' },
    { id: 'wtdv2-tell-someone', component: Slide8TellSomeone, label: 'Tell someone' },
    { id: 'wtdv2-recovery-scam', component: Slide9RecoveryScam, label: 'Watch for the second wave' },
    { id: 'wtdv2-finale', component: Slide10Finale, label: 'Course complete' },
  ],
}
